import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import GenericTemplateTemplate from './GenericTemplateTemplate'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class GenericTemplateComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.GENERIC_TEMPLATE)

    this.socket = config ? config.sockets : null
    this.data.component = GenericTemplateTemplate
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.GENERIC_TEMPLATE
    this.setConnection()
    
    const genericTemplateInput = new Rete.Input(
      CONST_SOCKET.GENERIC_TEMPLATE_INPUT, 
      lang.generic_template_socket_input_reply, 
      this.socket.genericTemplateInput,
      true
    )
    
    const genericTemplateOutput = new Rete.Output(
      CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT, 
      lang.generic_template_socket_output_next, 
      this.socket.genericTemplateOutput, 
      false
    )
    
    const genericTemplateOutputButton = new Rete.Output(
      CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_BUTTON, 
      lang.generic_template_socket_output_buttons, 
      this.socket.genericTemplateOutputButton, 
      true
    )

    const genericTemplateOutputQuickreply = new Rete.Output(
      CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_QUICKREPLY, 
      lang.generic_template_socket_output_quick_replies, 
      this.socket.genericTemplateOutputQuickreply, 
      true
    )

    node.addInput(genericTemplateInput)
    node.addOutput(genericTemplateOutput)
    node.addOutput(genericTemplateOutputButton)

    if (! instagram_addon) {
      node.addOutput(genericTemplateOutputQuickreply)
    }

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_BUTTON] = node.data
  }
  
  setConnection() {
    // GenericTemplate may be connected to:
    this.socket.genericTemplateOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.genericTemplateOutput.combineWith(this.socket.openaiInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.carouselInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.genericTemplateOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.genericTemplateOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.genericTemplateOutput.combineWith(this.socket.videoInput)
      this.socket.genericTemplateOutput.combineWith(this.socket.audioInput)
      this.socket.genericTemplateOutput.combineWith(this.socket.fileInput)
      // this.socket.genericTemplateOutput.combineWith(this.socket.otnInput)
    }

    if(recurring_notification_display)
      this.socket.genericTemplateOutput.combineWith(this.socket.rcnInput)
    
    this.socket.genericTemplateOutput.combineWith(this.socket.ecommerceInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.genericTemplateOutput.combineWith(this.socket.httpApiInput)
    }

    
    if (this.isUserInputFlowAddonAvailable) {
      this.socket.genericTemplateOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (Buttons): Buttons, QuickReply
    this.socket.genericTemplateOutputButton.combineWith(this.socket.buttonInput)
    this.socket.genericTemplateOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}